export const getSkeletonRows = (dataKey: string): Record<string, string>[] => {
  return Array.from({ length: 14 }, (_, index) => ({
    [dataKey]: `skeleton_${index}`,
  }));
}
